import { createRequestDeduper } from "@/utils/keyed-work"

/**
 * Dedupes in-flight workspace bootstrap work.
 * Used by GlobalSync.bootstrapDirectory so multiple SyncProviders (Grid tiles)
 * for one workspace share a single bootstrap run.
 */
export function createBootstrapGate(run: (directory: string, signal: AbortSignal) => Promise<void>) {
  const pending = createRequestDeduper<string, void>()
  const controllers = new Map<string, AbortController>()
  let runs = 0

  function cancel(directory: string) {
    controllers.get(directory)?.abort()
    controllers.delete(directory)
    pending.delete(directory)
  }

  return {
    bootstrap(directory: string) {
      if (!directory) return Promise.resolve()
      return pending.run(directory, async () => {
        runs += 1
        const controller = new AbortController()
        controllers.set(directory, controller)
        try {
          await run(directory, controller.signal)
        } finally {
          if (controllers.get(directory) === controller) controllers.delete(directory)
        }
      })
    },
    cancel,
    dispose() {
      for (const directory of controllers.keys()) cancel(directory)
    },
    runs: () => runs,
    pendingCount: () => pending.size(),
    isPending: (directory: string) => pending.has(directory),
  }
}
